import { render, staticRenderFns } from "./MyAcount.vue?vue&type=template&id=b429ff00"
import script from "./MyAcount.vue?vue&type=script&lang=js"
export * from "./MyAcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports